export const API_PATH = '/apps';
